/**
 * @desc 保存ebs推送的币种汇率
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: Array<defs.basics.EbsExchangeRateModel>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/ebsExchangeRate/saveCurrencyRate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
